import { LoadingStates } from '@hm-group/frontend-utils/request';
import { ACTIONS } from './constants';
// TODO: Change the any types BTPXFA-1535
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const requestReducer = (state, { type, payload }) => {
    switch (type) {
        case ACTIONS.FETCH_INIT:
            return Object.assign(Object.assign({}, state), { status: LoadingStates.Loading });
        case ACTIONS.FETCH_SUCCESS:
            return Object.assign(Object.assign({}, state), { status: LoadingStates.LoadedSuccess, data: payload.data, statusCode: payload.statusCode, error: undefined, headers: payload.headers });
        case ACTIONS.FETCH_FAILURE:
            return Object.assign(Object.assign({}, state), { status: LoadingStates.LoadedFail, error: payload });
        default:
            return state;
    }
};
export default requestReducer;
//# sourceMappingURL=requestReducer.js.map